module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn taxonomy"
  }, [(_vm.$route.name == 'Terms') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  }), _vm._v(" Terms\n          "), _c('router-link', {
    staticClass: "pull-right btn btn-success btn-sm",
    attrs: {
      "to": '/admin/taxonomy/terms/new',
      "exact": ""
    }
  }, [_vm._v("\n            New\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "vocabulary_dropdown"
  }, [_c('v-select', {
    staticClass: "v-select-game",
    attrs: {
      "options": _vm.vocabularies,
      "label": "name"
    },
    on: {
      "change": _vm.getSource
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [(option.name) ? _c('span', [_vm._v(_vm._s(option.name))]) : _vm._e()]
      }
    }], null, false, 3103874680),
    model: {
      value: (_vm.searchVocabulary),
      callback: function($$v) {
        _vm.searchVocabulary = $$v
      },
      expression: "searchVocabulary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by term title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item.id,
      attrs: {
        "data-id": item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [_c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": {
          name: 'TermsEdit',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          return _vm.$_deleteEntity(item, 'terms/', 'Term')
        }
      }
    }, [_vm._v("\n                      Delete "), _c('span', {
      ref: ("deleteBtnLoader_" + (item.id)),
      refInFor: true,
      staticClass: "btn-loader",
      staticStyle: {
        "display": "none"
      }
    })])], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (_vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('router-view')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-648b2598","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/taxonomy/terms/Index.vue
// module id = 927
// module chunks = 0